import styled from 'styled-components/macro';

export const StyledErrorPage = styled.div`
  padding: 14rem 0;
`;
